import React from "react";
import { motion } from "framer-motion";
import NodeLoader from "./NodeLoader";

// Brief inline analysis transition shown between steps (not a spinner).
export const StepTransition = ({ message, reduced = false }) => (
  <div
    className="flex flex-col items-center justify-center py-24 text-center"
    data-testid="step-transition"
    aria-live="polite"
  >
    <NodeLoader size={40} reduced={reduced} />
    <motion.p
      initial={reduced ? false : { opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="text-white/80 mt-5 text-base"
    >
      {message}
    </motion.p>
    {!reduced && (
      <div className="flex gap-1.5 mt-4">
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            className="h-1.5 w-1.5 rounded-full bg-[#1E6BFF]"
            animate={{ opacity: [0.3, 1, 0.3] }}
            transition={{ duration: 1.1, repeat: Infinity, delay: i * 0.18 }}
          />
        ))}
      </div>
    )}
  </div>
);

export default StepTransition;
